import React from 'react';
import PropTypes from 'prop-types';

import NextIcon from '@material-ui/icons/PlayArrow';

import { Button, Grid, Translation, Link, Blurred } from '../../common';
import question from '../../../assets/img/welcome/question.png';
import { DISCOURSE_DUTY_PDF } from '../../../constants/api';

import { getOneTimeToken } from '../../../utils/token';

export const DISCOURSE_DUTY_TITLE = 'DISCOURSE_DUTY_TITLE';
export const DISCOURSE_DUTY_TEXT = 'DISCOURSE_DUTY_TEXT';

const DemandExplanation = ({ styles, token, blur }) => {
  const onButtonClick = () => {
    getOneTimeToken().then((token) => {
      if (token) {
        window.open(DISCOURSE_DUTY_PDF(token), '_blank');
      }
    });
  };

  return (
    <div className={styles['demand-explanation__wrapper']}>
      <img
        className={styles['demand-explanation__question']}
        src={question}
        alt="question"
      />
      <Grid container alignItems="center" justify="center" spacing={3}>
        <Grid item sm={10} className={styles['demand-explanation__content']}>
          <Translation className={styles['demand-explanation__header']}>
            {DISCOURSE_DUTY_TITLE}
          </Translation>
          <Blurred blur={blur}>
            <Translation className={styles['demand-explanation__explanation']}>
              {DISCOURSE_DUTY_TEXT}
            </Translation>
          </Blurred>
        </Grid>
        <Grid
          item
          sm={2}
          className={styles['demand-explanation__next-button-wrapper']}
        >
          <Blurred blur={blur}>
            <Button
              id="page.home.component.demand-explanation.discourse-duty-button"
              className={styles['demand-explanation__next-button']}
              variant="fab"
              disabled={blur}
              onClick={blur ? undefined : onButtonClick}
            >
              <NextIcon
                className={styles['demand-explanation__next-button-icon']}
              />
            </Button>
          </Blurred>
        </Grid>
      </Grid>
    </div>
  );
};

DemandExplanation.propTypes = {
  styles: PropTypes.object,
  token: PropTypes.string,
};

export default DemandExplanation;
